import { render } from "./EmployeesArchive.vue?vue&type=template&id=7e37a732&scoped=true"
import script from "./EmployeesArchive.vue?vue&type=script&lang=js"
export * from "./EmployeesArchive.vue?vue&type=script&lang=js"

import "./EmployeesArchive.vue?vue&type=style&index=0&id=7e37a732&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e37a732"]])

export default __exports__